import { db } from './firebase';
import { collection, doc, getDoc, getDocs, setDoc, deleteDoc, serverTimestamp, onSnapshot } from 'firebase/firestore';

// ─── 공통 상수 ───
export const ARR_ENABLE = { Y: '사용', N: '사용중지' };
export const ARR_ADMIN_TYPE = { A: '관리자', S: '지점 관리자', T: '팀장', M: '직원' };
export const ARR_POPUP_TYPE = { B: '새창', L: '레이어' };

// 기존 tb_master 상수 (legacy module/master/class.Master.php)
export const ARR_IP_CHECK = { N: '모두로그인', Y: '특정 아이피 로그인' };
export const ARR_IPAD_CHECK = {
  N: '앱이 설치된 모든 기기',
  Y: '앱이 설치되고 인증된 기기',
  O: '앱이 설치 안된 모든 기기',
};
export const ARR_ARTICLE5_HOUR = {
  '10': '오전 10시', '11': '오전 11시', '12': '오전 12시',
  '13': '오후 1시', '14': '오후 2시', '15': '오후 3시',
  '16': '오후 4시', '17': '오후 5시', '18': '오후 6시',
};

// ─── 관리자 환경설정 (master) ─── legacy tb_master
// Firestore: settings/master 단일 문서
export async function fetchMaster() {
  const snap = await getDoc(doc(db, 'settings', 'master'));
  return snap.exists() ? snap.data() : {};
}
export async function saveMaster(data) {
  await setDoc(doc(db, 'settings', 'master'), {
    a_company: data.a_company || '',
    a_email: data.a_email || '',
    a_group_image: data.a_group_image || '',
    a_ip_check: data.a_ip_check || 'N',
    a_ipad_check: data.a_ipad_check || 'N',
    a_article5: data.a_article5 || 'Y',
    a_article5_hour: data.a_article5_hour || '15',
    a_mo_link: data.a_mo_link || 'N',
    // 콘텐츠 보호 설정 (사용='Y' / 사용중지='N')
    a_rmouse: data.a_rmouse || 'Y',   // 오른쪽 마우스
    a_copy: data.a_copy || 'Y',       // 글복사
    a_imgsave: data.a_imgsave || 'Y', // 사진 저장
    l_name: data.l_name || '',
    updatedAt: serverTimestamp(),
  }, { merge: true });
}

const today = () => new Date().toISOString().split('T')[0];

// ─── 지점관리 (stores) ───
export async function saveStore(storeIdx, data) {
  const id = storeIdx ? String(storeIdx) : String(Date.now());
  await setDoc(doc(db, 'stores', id), {
    idx: storeIdx || id,
    no: data.no || '',
    name: data.name || '',
    team: data.team || 0,
    tel1: data.tel1 || '', tel2: data.tel2 || '', tel3: data.tel3 || '',
    fax1: data.fax1 || '', fax2: data.fax2 || '', fax3: data.fax3 || '',
    zip: data.zip || '',
    addr1: data.addr1 || '', addr2: data.addr2 || '',
    lat: data.lat || '', lng: data.lng || '',
    image: data.image || '',
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
export async function deleteStore(storeId) {
  await deleteDoc(doc(db, 'stores', String(storeId)));
}

// ─── 관리자 IP (admin_ips) ───
export async function fetchAdminIps() {
  const snap = await getDocs(collection(db, 'admin_ips'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (Number(b.idx) || 0) - (Number(a.idx) || 0));
}
export async function saveAdminIp(id, data) {
  const docId = id || String(Date.now());
  await setDoc(doc(db, 'admin_ips', docId), {
    idx: id || docId,
    ip: data.ip || '',
    place: data.place || '',
    enable: data.enable || 'Y',
    regdate: data.regdate || today(),
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
export async function deleteAdminIp(id) {
  await deleteDoc(doc(db, 'admin_ips', String(id)));
}

// ─── Pad 관리 (pads) ───
export async function fetchPads() {
  const snap = await getDocs(collection(db, 'pads'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (Number(b.idx) || 0) - (Number(a.idx) || 0));
}
export async function savePad(id, data) {
  const docId = id || String(Date.now());
  await setDoc(doc(db, 'pads', docId), {
    idx: id || docId,
    pad_mcode: data.pad_mcode || '',
    pad_name: data.pad_name || '',
    pad_no: data.pad_no || '',
    pad_enable: data.pad_enable || data.enable || 'Y',
    regdate: data.regdate || today(),
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
export async function deletePad(id) {
  await deleteDoc(doc(db, 'pads', String(id)));
}

// ─── 공지사항/팝업 (popups) ───
export async function fetchPopups() {
  const snap = await getDocs(collection(db, 'popups'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (Number(b.p_idx) || 0) - (Number(a.p_idx) || 0));
}
export async function savePopup(id, data) {
  const docId = id || String(Date.now());
  await setDoc(doc(db, 'popups', docId), {
    p_idx: id || docId,
    p_title: data.p_title || '',
    p_content: data.p_content || '',
    p_img: data.p_img || '',
    p_enable: data.p_enable || 'Y',
    p_type: data.p_type || 'L',
    wdate: data.wdate || today(),
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
export async function deletePopup(id) {
  await deleteDoc(doc(db, 'popups', String(id)));
}

// ─── 모바일 링크 (mobile_links) ───
export async function fetchMobileLinks() {
  const snap = await getDocs(collection(db, 'mobile_links'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (Number(b.idx) || 0) - (Number(a.idx) || 0));
}
export async function saveMobileLink(id, data) {
  const docId = id || String(Date.now());
  await setDoc(doc(db, 'mobile_links', docId), {
    idx: id || docId,
    title: data.title || '',
    sns_link: data.sns_link || '',
    enable: data.enable || 'Y',
    wdate: data.wdate || today(),
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
export async function deleteMobileLink(id) {
  await deleteDoc(doc(db, 'mobile_links', String(id)));
}

// ─── 관리자 서비스 (admin_services) ───
export async function fetchAdminServices() {
  const snap = await getDocs(collection(db, 'admin_services'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (Number(a.as_order) || 0) - (Number(b.as_order) || 0));
}
export async function saveAdminService(id, data) {
  const docId = id || String(Date.now());
  await setDoc(doc(db, 'admin_services', docId), {
    as_code: data.as_code || docId,
    as_name: data.as_name || '',
    as_type: data.as_type || 'A',
    as_up_code: data.as_up_code || '',
    as_order: Number(data.as_order) || 0,
    as_enable: data.as_enable || 'Y',
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
export async function deleteAdminService(id) {
  await deleteDoc(doc(db, 'admin_services', String(id)));
}

// ─── 일정 역할별 색상 (schedule_colors) — DEPRECATED, 팀별 색상으로 대체 ───
export const DEFAULT_SCHEDULE_COLORS = {
  admin: '#DC2626',   // 관리자: 빨강 (고정)
  leader: '#3B82F6',  // 팀장: 파랑 (fallback)
  member: '#6B7280',  // 팀원: 회색 (fallback)
};
export async function fetchScheduleColors() {
  const snap = await getDoc(doc(db, 'settings', 'schedule_colors'));
  return snap.exists() ? { ...DEFAULT_SCHEDULE_COLORS, ...snap.data() } : { ...DEFAULT_SCHEDULE_COLORS };
}
export async function saveScheduleColors(data) {
  await setDoc(doc(db, 'settings', 'schedule_colors'), {
    admin: data.admin || DEFAULT_SCHEDULE_COLORS.admin,
    leader: data.leader || DEFAULT_SCHEDULE_COLORS.leader,
    member: data.member || DEFAULT_SCHEDULE_COLORS.member,
    updatedAt: serverTimestamp(),
  }, { merge: true });
}
export function getUserScheduleRole(user) {
  if (!user) return 'member';
  if (user.isAdmin || user.dept === '대표') return 'admin';
  if (user.dept === '팀장') return 'leader';
  return 'member';
}

// ─── 팀별 색상 (team_colors) — 지점+팀번호 기준 ───
// 관리자(대표/admin)는 ADMIN_FIXED_COLOR 고정 — team_colors와 무관
export const ADMIN_FIXED_COLOR = '#DC2626';
export const DEFAULT_TEAM_PALETTE = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#14B8A6', '#F97316'];
const hashKey = (str) => {
  let h = 0;
  for (let i = 0; i < (str || '').length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
};
// 팀키 → 기본 팔레트 색 (관리자가 색 지정 안 한 팀의 fallback)
export function defaultTeamColor(teamKey) {
  if (!teamKey || teamKey === '_') return DEFAULT_TEAM_PALETTE[0];
  return DEFAULT_TEAM_PALETTE[hashKey(teamKey) % DEFAULT_TEAM_PALETTE.length];
}
// teamKey 포맷: `${storeIdx}_${teamNo}`
export function makeTeamKey(storeIdx, teamNo) {
  return `${storeIdx || ''}_${teamNo || ''}`;
}
// user → teamKey
export function teamKeyOfUser(user) {
  if (!user) return '';
  return makeTeamKey(user.store_idx, user.team_no);
}
// user → 최종 색 (관리자는 고정색, 팀원은 team_colors[teamKey] || fallback)
export function resolveUserColor(user, teamColors) {
  if (!user) return ADMIN_FIXED_COLOR;
  const isAdmin = user.isAdmin || user.dept === '대표' || user.loginId === 'admin';
  if (isAdmin) return ADMIN_FIXED_COLOR;
  const key = teamKeyOfUser(user);
  if (!key || key === '_') return ADMIN_FIXED_COLOR;
  return (teamColors && teamColors[key]) || defaultTeamColor(key);
}
// teamKey → 최종 색
export function resolveTeamColor(teamKey, teamColors) {
  if (!teamKey || teamKey === '_') return ADMIN_FIXED_COLOR;
  return (teamColors && teamColors[teamKey]) || defaultTeamColor(teamKey);
}

export async function fetchTeamColors() {
  const snap = await getDoc(doc(db, 'settings', 'team_colors'));
  if (!snap.exists()) return {};
  const data = snap.data() || {};
  // updatedAt 등 메타 필드 제외, key=color 형태만 반환
  const out = {};
  Object.entries(data).forEach(([k, v]) => {
    if (k === 'updatedAt') return;
    if (typeof v === 'string' && v.startsWith('#')) out[k] = v;
  });
  return out;
}
export async function saveTeamColors(map) {
  const payload = { updatedAt: serverTimestamp() };
  Object.entries(map || {}).forEach(([k, v]) => {
    if (typeof v === 'string' && v.startsWith('#')) payload[k] = v;
  });
  await setDoc(doc(db, 'settings', 'team_colors'), payload);
}

// 팀별 색상 실시간 구독
export function subscribeTeamColors(cb) {
  return onSnapshot(doc(db, 'settings', 'team_colors'), (snap) => {
    if (!snap.exists()) return cb({});
    const data = snap.data() || {};
    const out = {};
    Object.entries(data).forEach(([k, v]) => {
      if (k === 'updatedAt') return;
      if (typeof v === 'string' && v.startsWith('#')) out[k] = v;
    });
    cb(out);
  });
}

// ─── 광고업체 관리 (advertisers) ───
// Firestore: advertisers 컬렉션 { id, name, order, enable }
// 모듈 캐시 — 여러 폼(이동방 인라인 / 이동보고 팝업)이 공유해, 폼 열 때마다 목록이
// 비었다 채워지는 깜빡임(가짜 fallback ↔ 실제 목록)을 방지. stale-while-revalidate.
let _advertisersCache = null;
export function getCachedAdvertisers() { return _advertisersCache; }
export async function fetchAdvertisers() {
  const snap = await getDocs(collection(db, 'advertisers'));
  const list = snap.docs.map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (Number(a.order) || 0) - (Number(b.order) || 0));
  _advertisersCache = list;
  return list;
}
export async function saveAdvertiser(id, data) {
  const docId = id || String(Date.now());
  await setDoc(doc(db, 'advertisers', docId), {
    name: data.name || '',
    order: Number(data.order) || 0,
    enable: data.enable || 'Y',
    updatedAt: serverTimestamp(),
  }, { merge: true });
  return docId;
}
export async function deleteAdvertiser(id) {
  await deleteDoc(doc(db, 'advertisers', String(id)));
}

// ─── 유튜브 채널 관리 (youtube_channels) ───
// Firestore: youtube_channels 컬렉션 { id, name, order, enable }
export async function fetchYoutubeChannels() {
  const snap = await getDocs(collection(db, 'youtube_channels'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (Number(a.order) || 0) - (Number(b.order) || 0));
}
export async function saveYoutubeChannel(id, data) {
  const docId = id || String(Date.now());
  const payload = {
    name: data.name || '',
    order: Number(data.order) || 0,
    enable: data.enable || 'Y',
    updatedAt: serverTimestamp(),
  };
  if (data.ownerMcodes !== undefined) {
    payload.ownerMcodes = Array.isArray(data.ownerMcodes)
      ? data.ownerMcodes.map(String).filter(Boolean)
      : [];
  }
  await setDoc(doc(db, 'youtube_channels', docId), payload, { merge: true });
  return docId;
}
export async function deleteYoutubeChannel(id) {
  await deleteDoc(doc(db, 'youtube_channels', String(id)));
}
